(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/remove', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/remove'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.remove, global.convert);
    global.remove = mod.exports;
  }
})(this, function (exports, _remove2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.remove = undefined;

  var _remove3 = _interopRequireDefault(_remove2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces an array removing elements that predicate returns truthy for from the former array.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {Function} [predicate={@link https://lodash.com/docs#identity|lodash.identity}] The function invoked per iteration.
   * @return {Object} Returns the updated object.
   * @example remove({ nested: { prop: [1, 2, 3, 4] } }, 'nested.prop', v => v > 2) // => { nested: { prop: [1, 2] } }
   * @see {@link https://lodash.com/docs#remove|lodash.remove} for more information.
   * @since 0.2.0
   */
  var remove = (0, _convert.convert)(function (array, predicate) {
    (0, _remove3.default)(array, predicate);
    return array;
  });
  exports.remove = remove;
  exports.default = remove;
});